import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// EN
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enHero from './locales/en/hero.json';
import enPrices from './locales/en/prices.json';
import enContacts from './locales/en/contacts.json';
import enProjects from './locales/en/projects.json';
import enGallery from './locales/en/gallery.json';
import enPolicies from './locales/en/policies.json';
import enDesign from './locales/en/design.json';
import enBrand from './locales/en/brand.json';
import enPackages from './locales/en/packages.json';
import enFaq from './locales/en/faq.json';
import enWebsitePrice from './locales/en/websitePrice.json';
import enBooking from './locales/en/booking.json';

// RU
import ruCommon from './locales/ru/common.json';
import ruHome from './locales/ru/home.json';
import ruHero from './locales/ru/hero.json';
import ruPrices from './locales/ru/prices.json';
import ruContacts from './locales/ru/contacts.json';
import ruProjects from './locales/ru/projects.json';
import ruGallery from './locales/ru/gallery.json';
import ruPolicies from './locales/ru/policies.json';
import ruDesign from './locales/ru/design.json';
import ruBrand from './locales/ru/brand.json';
import ruPackages from './locales/ru/packages.json';
import ruFaq from './locales/ru/faq.json';
import ruWebsitePrice from './locales/ru/websitePrice.json';
import ruBooking from './locales/ru/booking.json';

// FI
import fiCommon from './locales/fi/common.json';
import fiHome from './locales/fi/home.json';
import fiHero from './locales/fi/hero.json';
import fiPrices from './locales/fi/prices.json';
import fiContacts from './locales/fi/contacts.json';
import fiProjects from './locales/fi/projects.json';
import fiGallery from './locales/fi/gallery.json';
import fiPolicies from './locales/fi/policies.json';
import fiDesign from './locales/fi/design.json';
import fiBrand from './locales/fi/brand.json';
import fiPackages from './locales/fi/packages.json';
import fiFaq from './locales/fi/faq.json';
import fiWebsitePrice from './locales/fi/websitePrice.json';
import fiBooking from './locales/fi/booking.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon, home: enHome, hero: enHero, prices: enPrices, contacts: enContacts, projects: enProjects, gallery: enGallery, policies: enPolicies, design: enDesign, brand: enBrand, packages: enPackages, faq: enFaq, websitePrice: enWebsitePrice, booking: enBooking },
      ru: { common: ruCommon, home: ruHome, hero: ruHero, prices: ruPrices, contacts: ruContacts, projects: ruProjects, gallery: ruGallery, policies: ruPolicies, design: ruDesign, brand: ruBrand, packages: ruPackages, faq: ruFaq, websitePrice: ruWebsitePrice, booking: ruBooking },
      fi: { common: fiCommon, home: fiHome, hero: fiHero, prices: fiPrices, contacts: fiContacts, projects: fiProjects, gallery: fiGallery, policies: fiPolicies, design: fiDesign, brand: fiBrand, packages: fiPackages, faq: fiFaq, websitePrice: fiWebsitePrice, booking: fiBooking },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;